import "moment/locale/pt-br";
import "react-datetime/css/react-datetime.css";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
    FormControl,
    FormErrorMessage,
    FormLabel,
    Flex,
    Input,
    useColorModeValue,
    useDisclosure,
} from "@chakra-ui/react";
import { FilterContainer } from "components/Tables/FilterContainer";
import DateTime from "react-datetime";
import { LOCALE_PT_BR } from "constants/date-time";

export const DocumentsFilter = (props) => {
    const { t } = useTranslation('common');
    const { onFilter, parentType } = props;
    const { isOpen, onToggle } = useDisclosure();
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const placeholderColor = useColorModeValue("gray.300", "gray.400");

    const onFilterHandler = () => {
        onFilter({
            data_inicial: startDate ? new Date(startDate).toLocaleDateString(LOCALE_PT_BR) : "",
            data_final: endDate ? new Date(endDate).toLocaleDateString(LOCALE_PT_BR) : "",
        });
    }

    const onClearHandler = () => {
        setStartDate("");
        setEndDate("");

        onFilter({ startDate: null, endDate: null });
    }

    return (
        <FilterContainer
            w='125px'
            fontSize='sm'
            fontWeight='bold'
            variant="light"
            isOpen={isOpen}
            onToggle={onToggle}
            onFilter={onFilterHandler}
            onClear={onClearHandler}
        >
            <Flex w="100%" gap="4" justify="space-between">
                <FormControl w="230px">
                    <FormLabel>
                        {t(parentType === "credenciais-estacionamento" ? "parking-credentials.documents.labels.start-date"
                        : "system.labels.start-date")}
                    </FormLabel>
                    <DateTime
                        locale={LOCALE_PT_BR}
                        closeOnSelect
                        timeFormat={false}
                        inputProps={startDate ? undefined : { value: "", placeholder: t("system.placeholders.date") }}
                        renderInput={(props) => (
                          <Input
                            {...props}
                            fontSize="sm"
                            _placeholder={{ color: placeholderColor, fontSize: "sm" }}
                          />
                        )}
                        onChange={date => setStartDate(date)} />
                    <FormErrorMessage>
                        {t("system.messages.errors.invalid-start-date")}
                    </FormErrorMessage>
                </FormControl>

                <FormControl w="230px">
                    <FormLabel>
                        {t(parentType === "credenciais-estacionamento" ? "parking-credentials.documents.labels.end-date"
                        : "system.labels.end-date")}
                    </FormLabel>
                    <DateTime
                        locale={LOCALE_PT_BR}
                        closeOnSelect
                        timeFormat={false}
                        inputProps={endDate ? undefined : { value: "", placeholder: t("system.placeholders.date") }}
                        renderInput={(props) => (
                          <Input
                            {...props}
                            fontSize="sm"
                            _placeholder={{ color: placeholderColor, fontSize: "sm" }}
                          />
                        )}
                        onChange={date => setEndDate(date)} />
                    <FormErrorMessage>
                        {t("system.messages.errors.invalid-end-date")}
                    </FormErrorMessage>
                </FormControl>
            </Flex>
        </FilterContainer>
    );
}